import React, { useState } from 'react';
import { ColumnInstance } from 'react-table';

import { PRIMARY_GRAY_SHADE, SECONDARY_GRAY_SHADE } from '../../../utils/constants/colors';
import usePrevious from '../../../hooks/usePrevious';
import Sort from '../../icons/Sort';
import * as styles from './styles/styles.module.scss';

type TableHeaderProps = {
  column: ColumnInstance<any>;
};

const TableHeader = ({ column }: TableHeaderProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);
  const prevIsHovered = usePrevious(isHovered);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const { isSorted, isSortedDesc } = column;
  // This check is to prevent rendering with hover colors immediately after the user clicks on a header
  // Intent is for the rendered icon to display the current sorting state after the click has occurred
  const isNewlyHovered = isHovered && prevIsHovered === false;
  // Hover logic assumes changes to sorting occur in the following repeating pattern:
  // unsorted -> ascending -> descending -> ...
  const isAsc = isNewlyHovered ? !isSorted : isSorted && !isSortedDesc;
  const isDesc = isNewlyHovered ? isSorted && !isSortedDesc : isSorted && isSortedDesc;
  const ascColor = isAsc ? SECONDARY_GRAY_SHADE : PRIMARY_GRAY_SHADE;
  const descColor = isDesc ? SECONDARY_GRAY_SHADE : PRIMARY_GRAY_SHADE;

  return (
    <th onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...column.getHeaderProps(column.getSortByToggleProps())}>
      <span>{column.render('Header')}</span>
      {column.canSort && <Sort className={styles.sortIcons} ascColor={ascColor} descColor={descColor} />}
    </th>
  );
};

export default TableHeader;
